import { baseURL, moduleName } from "../../../controllers/api/globalEndpoint.api";

const conversationEndPoint = {
    getConversationUniqueList: baseURL + moduleName.auth + moduleName.chatbot + '/conversations',
};

export default conversationEndPoint;